// .config(['$uibTooltipProvider',


/* @ngInject */
export default function uibTooltipConfig($uibTooltipProvider) {
    const triggers = {};
    triggers.show = 'hide';

    $uibTooltipProvider.setTriggers(triggers);
}




// WEBPACK FOOTER //
// ./src/app/config/uibTooltip.config.js